import React from "react"
import styles from "./panel.module.css"

const Panel = (props) => {
    return (
        <div className={styles.panel} style={props.style}>
            <div className={styles.panelHeader}>
                <h2 className={styles.panelTitle}>{props.title}</h2>
            </div>
            <div className={styles.panelContent}>
                {props.children}
            </div>
        </div>
    )
}

export default Panel;